import React/*, {useRef}*/ from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers, withState } from 'recompose'
import { FormattedMessage } from 'react-intl'
import Swiper from 'react-id-swiper'
/*import LotsList from './LotList/index'
import Hero from './../components/Hero'
import NewsList from '../components/News/PreviewList'
import FundsList from '../components/Funds/PreviewList'*/
import Link from './../components/Link'
import { fetchingState } from '../helpers/hocs.js'

import {getList as getFAQ} from './../store/reducers/about'
import { getTotalSum } from '../selectors/home.js'
import { getHomeData } from './../store/reducers/home'
//import { get as getNews } from './../store/reducers/news'
import {  } from './../store/reducers/partners'
import { getFunds as getFundsSelector } from './../selectors/funds.js'
import { /*clearList,*/ getFunds, getTotal as getTotalFunds } from './../store/reducers/funds/list.js'
//import HelpForm from '../components/HelpForm'
import Hide from './../components/Hide'
import FileLogo from '../components/Icons/File'
//import InnerHTML from 'script-inner-html'
import { getApproximateTotalSum } from '../helpers/hocs.js'

// const params = {
//   //effect: 'coverflow',
//   grabCursor: false,//true
//   centeredSlides: true,
//   slidesPerView: 'auto',
//   loop: true,
//   navigation: {
//     hide: true
//   },
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true,
//   },
//   autoplay: true,
// }
const params1 = {
  grabCursor: false,//true
  centeredSlides: true,
  //slidesPerView: 'auto',
  //slidesPerView: 3,
  //slidesPerColumn: 3,
  //slidesPerGroup: 3,
  //centeredSlidesBounds: true,
  //loopedSlides: 3,
  //slidesOffsetBefore: 50,
  //slidesOffsetAfter: 50,
  //watchSlidesVisibility: true,
  loop: true,
  //setWrapperSize: true, размер картинок по ширине окна
  //roundLengths: true,
  //spaceBetween: 30,
  navigation: {
    nextEl: '.AboutUs__swiper1-button-next1',
    prevEl: '.AboutUs__swiper1-button-prev1',
    hide: true
  },
  slidesPerView: 'auto',
  //autoplay: {delay: 2000, disableOnInteraction: false},
  //rebuildOnUpdate: true,
}
const params_logos = {
  grabCursor: false,//true
  centeredSlides: true,
  loop: true,
  rebuildOnUpdate: true,
  spaceBetween: 30,
}

// let params2 = {
//   grabCursor: false,//true
//   centeredSlides: true,
//   //slidesPerView: 'auto',
//   loop: true,
//   //slidesPerGroup: 11,
//   //slidesPerView: 3,
//   //slidesPerColumn: 3,
//   spaceBetween: 30,
//   /*navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//     hide: false
//   },*/
//   //autoplay: true,
//   rebuildOnUpdate: true
// }

const paramsVideo = {
  grabCursor: false,//true
  centeredSlides: true,
  slidesPerView: 'auto',
  //watchSlidesVisibility: true,
  loop: true,
  /*navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
    hide: false
  },*/
  autoplay: false,//{delay: 2000, disableOnInteraction: false},
}

const AboutUs = ({faq = [], funds = [], news = [], total = 0, fundsTotal, actions = [], actionsCount, partners,//fetching
  items = [], totalExtPartners = 0, length = 0, fetching, loadMore, sum = 0, count = 0, checkout, nextState, focusSlide, setFocusSlide, ordinaryMode }) => {//fetching ? null :
  const /*index = 0,*/ setIndex = 0;// = useState(0);

  // const handleSelect = (selectedIndex, e) => {
  //   setIndex(selectedIndex);
  // };


  let logos = [
  {
    _id: '23', image: '/assets/img/logos/village.png', title: 'village',
    link: 'https://www.cosmo.ru/stars/news/04-04-2020/meet-for-charity-i-kseniya-sobchak-proveli-blagotvoritelnyy-on-layn-aukcion/'
  },
  {
    _id: '24', image: '/assets/img/logos/harpers_bazaar.png', title: 'harpers_bazaar',
    link: 'https://www.marieclaire.ru/stil-zjizny/olga-fler-v-teoriyu-shesti-rukopojatiy-ya-veryu-kak-nikto-drugoy-/'
  },
  {
    _id: '25', image: '/assets/img/logos/buro.png', title: 'buro',
    link: 'https://www.marieclaire.ru/stil-zjizny/pravila-legkoy-blagotvoritelnosti-ili-kak-pomogat-kajdyiy-den/'
  },
  //{ _id: '26', image: '/assets/img/logos/marie_claire.png', title: 'marie_claire' },
  {
    _id: '27', image: '/assets/img/logos/cosmopolitan.png', title: 'cosmopolitan',
    link: 'https://www.marieclaire.ru/stil-zjizny/olga-fler-v-teoriyu-shesti-rukopojatiy-ya-veryu-kak-nikto-drugoy-/'
  },
  { _id: '28', image: '/assets/img/logos/voice.png', title: 'voice' },
  { _id: '29', image: '/assets/img/logos/symbol.png', title: 'symbol' },
  { _id: '30', image: '/assets/img/logos/marie_claire2.png', title: 'marie_claire2' },
  { _id: '31', image: '/assets/img/logos/umag.png', title: 'umagazine' },];

  // let quotes = [{ _id: '31', image: '/assets/img/test/quotes/quote1.png' },
  // { _id: '32', image: '/assets/img/test/quotes/quote2.png' },
  // { _id: '33', image: '/assets/img/test/quotes/quote3.png' },
  // { _id: '34', image: '/assets/img/test/quotes/quote4.png' }];

  // let infoPartners = [{ id: '41', image: '/assets/img/test/infoPartners/tatler.png', text: 'TatlerLogo' },
  // { id: '42', image: '/assets/img/test/infoPartners/the_village.png', text: 'theVillageLogo' },
  // { id: '43', image: '/assets/img/test/infoPartners/Harpers_Bazaar_logo.png', text: 'HarpersBazaarlogo' },
  // { id: '44', image: '/assets/img/test/infoPartners/buro.png', text: 'Buro' },
  // { id: '45', image: '/assets/img/test/infoPartners/marie_claire.png', text: 'MarieClaireLogo' },
  // { id: '46', image: '/assets/img/test/infoPartners/cosmo.png', text: 'CosmoLogo' }]

  let partnersArr = [
    { id: '501', on: false, image: '/assets/img/persons/new/01.png', secondImage: '/assets/img/persons/new/01.png', text: 'Александр Петров',
    link: '/members/5e86f5ab9ad50f282c2505b0'  },
    { id: '503', on: false, image: '/assets/img/persons/new/03.png', secondImage: '/assets/img/persons/new/03.png', text: 'Алена Долецкая',
    link: '/members/5d7f822be11d130428e154b5'  },
    { id: '506', on: false, image: '/assets/img/persons/new/06.png', secondImage: '/assets/img/persons/new/06.png', text: 'Андрей Малахов',
    link: '/members/5a3698d12f89440bd89b383c'  },
    { id: '507', on: false, image: '/assets/img/persons/new/07.png', secondImage: '/assets/img/persons/new/07.png', text: 'Анна Цуканова-Котт',
    link: '/members/anna_cukanova-kott_-_aktrisa_teatra_i_kino_sozdatel_fud-proekta_kinoeda_202102'  },
    { id: '508', on: false, image: '/assets/img/persons/new/08.png', secondImage: '/assets/img/persons/new/08.png', text: 'Анна Чиповская',
    link: '/members/5ad7264a7a86d3354a413e7b'  },
    { id: '509', on: false, image: '/assets/img/persons/new/09.png', secondImage: '/assets/img/persons/new/09.png', text: 'Артем Королев',
    link: '/members/artem_korolyov_-_televedushchiy_radiovedushchiy_akter_202012'  },
    { id: '510', on: false, image: '/assets/img/persons/new/10.png', secondImage: '/assets/img/persons/new/10.png', text: 'Светлана Бондарчук',
    link: '/members/_202011'  },
    { id: '512', on: false, image: '/assets/img/persons/new/12.png', secondImage: '/assets/img/persons/new/12.png', text: 'Владимир Мухин',
    link: '/members/5e173de613c3d442b7e08569'  },
    { id: '513', on: false, image: '/assets/img/persons/new/13.png', secondImage: '/assets/img/persons/new/13.png', text: 'Денис Симачев',
    link: '/members/denis_simachev_-__legenda_rossiyskogo_feshn_dizayner_rezhisser_restorator_202011'  },
    { id: '514', on: false, image: '/assets/img/persons/new/14.png', secondImage: '/assets/img/persons/new/14.png', text: 'Евгений Маргулис',
    link: '/members/evgeniy_margulis_-_sovetskiy_i_rossiyskiy_pevec_gitarist_202012'  },
    { id: '517', on: false, image: '/assets/img/persons/new/17.png', secondImage: '/assets/img/persons/new/17.png', text: 'Ирина Хакамада',
    link: '/members/5b0bc43d7a86d3354a41459e'  },
    { id: '518', on: false, image: '/assets/img/persons/new/18.png', secondImage: '/assets/img/persons/new/18.png', text: 'Катерина Шпица',
    link: '/members/katerina_shpica_-_rossiyskaya_aktrisa_teatra_i_kino_202012'  },
    { id: '519', on: false, image: '/assets/img/persons/new/19.png', secondImage: '/assets/img/persons/new/19.png', text: 'Ксения Собчак',
    link: '/members/5b39c4857a86d3354a414c7e'  },
    { id: '520', on: false, image: '/assets/img/persons/new/20.png', secondImage: '/assets/img/persons/new/20.png', text: 'Мария Ивакова',
    link: '/members/5c73d9be9c6765315a12f88c'  },
    { id: '522', on: false, image: '/assets/img/persons/new/22.png', secondImage: '/assets/img/persons/new/22.png', text: 'Покрас Лампас',
    link: '/members/pokras_lampas_-_rossiyskiy_hudozhnik_kalligraf__202009'  },
    { id: '524', on: false, image: '/assets/img/persons/new/24.png', secondImage: '/assets/img/persons/new/24.png', text: 'Сергей Капков',
    link: '/members/sergey_kapkov_-_rukovoditel_centra_issledovaniy_mgu_202103'  },
    { id: '525', on: false, image: '/assets/img/persons/new/25.png', secondImage: '/assets/img/persons/new/25.png', text: 'Слава Полунин',
    link: '/members/5d721282e11d130428e15309'  },
    { id: '526', on: false, image: '/assets/img/persons/new/26.png', secondImage: '/assets/img/persons/new/26.png', text: 'Теодор Курентзис',
    link: '/members/5c17a4291ae8cd06d4cd7391'  },
    { id: '527', on: false, image: '/assets/img/persons/new/27.png', secondImage: '/assets/img/persons/new/27.png', text: 'Федор Бондарчук',
    link: '/members/5e68f6a9b2eda82220df9dd8'  },
  ]

  let team = [
    {
      text: 'Ольга Флер',
      id: '101',
      on: false,
      image: '/assets/img/aboutus/team/olga-fler.png',
      email: '',
      job: 'Основатель',
      link: ''
    },
    {
      text: 'Александра Савочкина',
      id: '102',
      job: 'Директор',
      on: false,
      image: '/assets/img/aboutus/team/aleksandra-savochkina.png',
      email: '',
      link: ''
    },
    {
      text: 'Анна Дюканова',
      id: '103',
      on: false,
      image: '/assets/img/aboutus/team/anna-dyukanova.png',
      email: '',
      job: 'Директор по развитию ',
      link: ''
    },
    {
      text: 'Мария Немчина',
      id: '104',
      on: false,
      image: '/assets/img/aboutus/team/mariya-nemchina.png',
      email: '',
      job: 'Руководитель проектов',
      link: ''
    },
    {
      text: 'Лина Колпакова',
      id: '105',
      on: false,
      image: '/assets/img/aboutus/team/lina-kolpakova.png',
      email: '',
      job: 'Специалист по работе с фондами',
      link: ''
    },
    {
      text: 'Лилия Писарева',
      id: '106',
      on: false,
      image: '/assets/img/aboutus/team/liliya-pisareva.png',
      email: '',
      job: 'Менеджер сервисного отдела',
      link: ''
    },
    // {
    //   text: 'Яна Донцова',
    //   id: '107',
    //   on: false,
    //   image: '/assets/img/aboutus/team/yana-doncova.png',
    //   email: '',
    //   job: 'Менеджер сервисного отдела',
    //   link: ''
    // },
    {
      text: 'Мария Степанчук',
      id: '108',
      on: false,
      image: '/assets/img/aboutus/team/mariya-stepanchuk.png',
      email: '',
      job: 'Event-менеджер',
      link: ''
    },
    {
      text: 'Виолетта Данилова',
      id: '109',
      on: false,
      image: '/assets/img/aboutus/team/violetta-danilova.png',
      email: '',
      job: 'SMM-специалист',
      link: ''
    },
    {
      text: 'Надежда Рубанова',
      id: '110',
      on: false,
      image: '/assets/img/aboutus/team/nadezhda-rubanova.png',
      email: '',
      job: 'Аккаунт-менеджер',
      link: ''
    },
    {
      text: 'Анастасия Кирьянова',
      id: '111',
      on: false,
      image: '/assets/img/aboutus/team/anastasiya-kiryanova.png',
      email: '',
      job: 'Копирайтер',
      link: ''
    },
    {
      text: 'Ольга Горбенко',
      id: '112',
      on: false,
      image: '/assets/img/aboutus/team/olga-gorbenko.png',
      email: '',
      job: 'Главный бухгалтер',
      link: ''
    },

    // { id: '102', on: false, image: '/assets/img/aboutus/team/01.png', text: 'Алина Ковалева', email:'', job:'Партнер', link: ''  },
    // { id: '107', on: false, image: '/assets/img/aboutus/team/07.PNG', text: 'Наталья Кузьмина', email:'natalia.kuzmina@meetforcharity.today', job:'Управляющий директор', link: ''  },
	  // { id: '105', on: false, image: '/assets/img/aboutus/team/02.png', text: 'Ирина Фалева', email:'irinafaleva@meetforcharity.today', job:'Директор по работе с партнерами', link: ''  },
    // { id: '106', on: false, image: '/assets/img/aboutus/team/03.png', text: 'Екатерина Кухтина', email:'ekukhtina@meetforcharity.today', job:'PR-директор', link: ''  },
  ]

  let fundsArr = [
		{ id: '59e065c69c1d521a86c6cb25', name: 'Дом с маяком' },
		{ id: '59c2950d3a8eb0652ed7a807', name: 'Линия Жизни' },
		{ id: '5f313901cb758143ad22f3c8', name: 'Онкологика' },
		{ id: '59e069f09c1d521a86c6cb35', name: 'ОРБИ' },
		{ id: '59c368f71b51e7737460cae1', name: 'Антон тут рядом' },
		{ id: '59e079ed9c1d521a86c6cb52', name: 'Детские Сердца' },
		{ id: '5bc73fe29c07e24ae97ba99b', name: 'Движение вверх' },
		{ id: '59fa0bad94c3a65d1eba1b35', name: 'Ночлежка' },
		//{id: '5b08337f7a86d3354a41457a', name: 'WWF'},
	];

  let formats = [{ id: '61', image: '/assets/img/test/formats/banner1.png' },
  { id: '62', image: '/assets/img/test/formats/banner2.png' },
  { id: '63', image: '/assets/img/test/formats/banner3.png' },
  { id: '64', image: '/assets/img/test/formats/banner4.png' },
  { id: '65', image: '/assets/img/test/formats/banner5.png' },
  { id: '66', image: '/assets/img/test/formats/banner6.png' }]

  let stats = [{ id: '71', header: '>9000', subheader: 'проведенных аукционов' },
  { id: '72', header: '>610 млн', subheader: 'собранных средств' },
  { id: '73', header: '>10 лет', subheader: 'в благотворительности' },
  //{ id: '73', header: '>360', subheader: 'встреч за 2020 год' },
  // { id: '74', header: '78 000 ₽', subheader: 'средний чек' },
  { id: '75', header: '3 900 000 ₽', subheader: 'максимальный чек' },
  { id: '76', header: '>200', subheader: 'фондов-партнеров' },
  //{ id: '77', header: '>1 млн', subheader: 'аудитория проекта' },
  //{ id: '78', header: '>3000', subheader: 'постоянных меценатов' },
  ]

  let videoArr = [{ id: '81', url: "https://www.youtube.com/embed/PY5OQkeGhb4", text: '' },
  { id: '82', url: "https://www.youtube.com/embed/Rhevd5WbrLQ", text: '' },
  { id: '83', url: "https://www.youtube.com/embed/wW9R_rJSTNE", text: '' },
  { id: '84', url: "https://www.youtube.com/embed/xxcUONM8qPM", text: '' },
  { id: '85', url: "https://www.youtube.com/embed/lnt5RT2TPfQ", text: '' },
  { id: '86', url: "https://www.youtube.com/embed/JqhYRuRubGI", text: '' },
  { id: '87', url: "https://www.youtube.com/embed/MYnzGNll5Wk", text: '' },
  { id: '88', url: "https://www.youtube.com/embed/i5vhN4GRYyk", text: '' },
  { id: '89', url: "https://www.youtube.com/embed/HTQJRJHudp8", text: '' },
  ]

  const questionsArr = [{id: '91', title: 'Как это работает', text: 'Хотите встретиться с кем-то из участников и поддержать тех, кто в этом нуждается? Делайте ставки в интересующих вас аукционах. И, если ваша ставка окажется победной, поздравляем – встреча ваша!'},
  {id: '92', title: 'Сколько длится аукцион?', text: 'Чтобы выиграть встречу у вас есть от 5 до 7 дней, в течение которых длятся аукционы Meet For Charity.'},
  {id: '93', title: 'Как происходит оплата «лота»?', text: 'Средства с карты списываются автоматически только в случае победы в аукционе!'},
  {id: '94', title: 'Как происходит сама встреча?', text: 'Как только вы сделаете благотворительное пожертвование, сотрудник Meet For Charity свяжется с вами и согласует удобные для вас дату, время и место встречи. Участники Meet For Charity встречаются в городских кафе и ресторанах. Это также может быть полноценный бизнес-завтрак или ужин – все зависит от желания самих участников.'},
  {id: '95', title: 'Куда идут средства?', text: 'Выигравшая ставка отправляется в один из благотворительных фондов-партнеров. Meet For Charity сотрудничает более чем 100 фондами, и этот список регулярно пополняется. Фонд, которому будут переведены средства, выбирает сам «лот» – герой аукциона, либо Meet For Charity, исходя из актуальных запросов от фондов.'},
  {id: '96', title: 'Что получает Meet For Charity?', text: 'Мы стремимся сделать Meet For Charity более удобным и эффективным, чтобы привлекать большее количество средств на благотворительность. Поэтому мы удерживаем комиссию с каждой транзакции и реинвестируем их в маркетинг и развитие продукта.'}]

  let totalString = getApproximateTotalSum(total)

  function mouseOnSlide(el, bool) {
    bool ? setFocusSlide(el.id) : setFocusSlide(undefined)
  }

  this.swiperRef1 = null
  this.swiperRef2 = null
  this.swiperRefVideo = null

  const goNext = (ref) => {
    if (ref && ref.swiper) {
      ref.swiper.slideNext();
    }
  };
  const goPrev = (ref) => {
    if (ref && ref.swiper) {
      ref.swiper.slidePrev();
    }
  };

  return (
    <div className='AboutUs'>
      <div className='Container Container_no-top Container_light Container_white'>
        <div className="AboutUs__top">
          <div className="AboutUs__header">
            <span style={{color: '#000'}}>Meet For Charity</span> – это крупнейший в России благотворительный аукцион встреч с известными людьми.
          </div>
          <div className="AboutUs__Big">
            Более 610 млн ₽
          </div>
          <div className="AboutUs__header">
            собрано на благотворительность за 10 лет
          </div>
        </div>

      </div>
      <div className='Container AboutUs__bottom'>
        {/*<div className='Container'>*/}
        <div className="AboutUs__white">
          <div className="AboutUs__margin-l">
            <div className="AboutUs__header">
              Как мы помогаем?
            </div>
            <div className="AboutUs__text">
              Каждый день мы разыгрываем встречи с известными людьми - представителями бизнеса, медиа, культуры, политики
              и спорта - в поддержку разных благотворительных фондов.
            </div>
          </div>

          <div className="AboutUs__Orange">
            <div className="AboutUs__header">
              Как внести свой вклад?
            </div>
            <div className="AboutUs__text">
            Вы можете помочь нам улучшить сферу благотворительности в России, поддержав проект. Мы ценим каждый вклад и в разы преумножаем его, разрабатывая новые инструменты помощи для тех, кому она особенно необходима.
            </div>
            {/*<div className="AboutUs__Button">
              <Link to='/contacts' className='Button Button_black'>
                Присоединиться
              </Link>
            </div>*/}
            {/*<div className="AboutUs__donate">
              <HelpForm notRequired={{'name': true, 'phone': true}} hide={{'phone': true}}/>
            </div>*/}
            <div className="AboutUs__donate">
              <Link to='/help' className='Button Button_black'>
                Хочу помочь!
              </Link>
            </div>
          </div>

          <div className="AboutUs__margin-m">
            <div className="AboutUs__header">
              Наши герои
            </div>
            <div className="AboutUs__swiper1-wrap">
                {/* <button onClick={()=>goPrev(this.swiperRef1)} className="AboutUs__swiper1-button-prev"></button> */}


              {/* <Swiper {...params1}  ref={instance=>this.swiperRef1=instance} className="AboutUs__swiper1" slidesPerView={(window.innerWidth < 667) ? 1 : 3}>
                {partnersArr.map((el, index) =>
                (
                  <dev className='AboutUs__item-body' key={el.id}>
                    <span className='AboutUs__item-img-wrap'>
                      <a href={el.link}><img className='AboutUs__item-img_partners' src={(el.id == focusSlide) ? el.secondImage : el.image} alt={el.text}
                      onMouseEnter={()=>mouseOnSlide(el, true)} onMouseLeave={()=>mouseOnSlide(el, false)}/></a>
                    </span>
                    <span className='AboutUs__item-caption-withgap'>
                    <span className='AboutUs__item-label'>{el.text}</span>
                    </span>
                  </dev>
                ))}
              </Swiper> */}

              <Swiper {...params1}  ref={instance=>this.swiperRef1=instance} className="AboutUs__swiper1" slidesPerView={(window.innerWidth < 667) ? 1 : 3}>
                {partnersArr.map((el, index) =>
                (
                  <div className='AboutUs__item-body' key={el.id}>
                    <span className='AboutUs__item-img-wrap'>
                      <a href={el.link}><img className='AboutUs__item-img_partners' src={(el.id == focusSlide) ? el.secondImage : el.image} alt={el.text}
                      onMouseEnter={()=>mouseOnSlide(el, true)} onMouseLeave={()=>mouseOnSlide(el, false)}/></a>
                    </span>
                    <span className='AboutUs__item-caption-withgap'>
                    <span className='AboutUs__item-label'>{el.text}</span>
                    </span>
                  </div>
                ))}
              </Swiper>

              {/* <button onClick={()=>goNext(this.swiperRef1)} className="AboutUs__swiper1-button-next"></button> */}
              </div>

              <div className="AboutUs__text">
                Мы помогаем более 200 благотворительным фондам:&nbsp;
                {fundsArr.map((el, index) =>

                (
                  <dev key={el.id}>
                    <Link to={`/funds/${el.id}`} className='Link'><span className="AboutUs__text-orange">{el.name}</span>{(index != (funds.length - 1)) &&  <span >, </span>}</Link>
                  </dev>
                ))} и многим другим.
              </div>
          </div>

          {/*<div className="AboutUs__margin-m">
            <div className="AboutUs__header">
              Кому мы помогаем
            </div>
            <div className="AboutUs__swiper1-wrap">
              <button onClick={()=>goPrev(this.swiperRef2)} className="AboutUs__swiper1-button-prev"></button>
              <Swiper {...params2 } ref={instance => this.swiperRef2 = instance} slidesPerView={ordinaryMode ? 1 : 3} slidesPerColumn={ordinaryMode ? 1 : 3}>
                {partnersArr.map(el => (
                  <dev className={ordinaryMode ? 'AboutUs__item-body' : 'AboutUs__item-body-sm'} key={el.id}>
                    <span className={ordinaryMode ? 'AboutUs__item-img-wrap' : 'AboutUs__item-img-wrap-sm'}>
                      <a href={el.link}><img className={ordinaryMode ? 'AboutUs__item-img_partners' : 'AboutUs__item-img_sm'}  src={el.image} alt={el.text} /></a>
                    </span>
                  </dev>
                ))}
              </Swiper>
              <button onClick={()=>goNext(this.swiperRef2)} className="AboutUs__swiper1-button-next"></button>
            </div>
          </div>  */}
        </div>

        <div className=" AboutUs__Black">
          <div className="AboutUs__margin">
            <div className="AboutUs__xl AboutUs__OrangeText">
              Миссия Meet For Charity <span style={{color: "#fff"}}>–</span>
            </div>
            <div className="AboutUs__header AboutUs__WhiteText">
              системное развитие благотворительности в России с помощью современных инструментов и креативных решений.
            </div>

            <div className="AboutUs__table2">
              <div className="AboutUs__table2-cell">
                <img className='AboutUs__table2-img' src='/assets/img/aboutus/bullet.jpg' alt='bullet' />
                <span className='AboutUs__table2-text'>Мы знаем, как важна возможность внести свой вклад в значимое дело. И верим, что делать это нужно с интересом.</span>
              </div>
              <div className="AboutUs__table2-cell">
                <img className='AboutUs__table2-img' src='/assets/img/aboutus/bullet.jpg' alt='bullet' />
                <span className='AboutUs__table2-text'>Meet For Charity предлагает новые способы участия в благотворительности, превращая ее в уникальный экспириенс.</span>
              </div>
              <div className="AboutUs__table2-cell">
                <img className='AboutUs__table2-img' src='/assets/img/aboutus/bullet.jpg' alt='bullet' />
                <span className='AboutUs__table2-text'>Здесь вы не просто помогаете - вы приобретаете новый опыт и вдохновляющее общение с выдающимися людьми.</span>
              </div>
            </div>
          </div>
        </div>

        <div className="AboutUs__white">
          {/*<div className="AboutUs__margin-l">
            <div className="AboutUs__header">
              Почему именно мы?
            </div>
            <div className="AboutUs__text">
              Начав в 2016 году с благотворительных аукционов встреч, Meet For Charity развился в мультипрофильный благотворительный проект.
            </div>
            <div className="AboutUs__text">
              Мы не просто помогаем благотворительным фондам - мы создаем средувзаимопомощи и энергообмена,
              где каждый участник получает нечто ценное. С нами вы не просто делает пожертвования - вы приобретаете новый опыт,
              вдохновляющее общение с выдающимися людьми и уникальный экспириенс.
            </div>
          </div>*/}

          <div className="AboutUs__margin-m">
            <div className="AboutUs__header">
              Meet For Charity в цифрах
            </div>
            <div className="AboutUs__table">
              {stats.map(el => (
                <div className="AboutUs__table-cell" key={el.id}>
                  <div className="AboutUs__table-header">{el.header}</div>
                  <div className="AboutUs__table-subheader">{el.subheader}</div>
                </div>
              ))}
            </div>
          </div>

          {/* <div className="AboutUs__margin-m"> TEMP HIDE
            <div className="AboutUs__header">
              О нас пишут
            </div> */}
            {/*<div className="AboutUs__logo-wrap">
              {logos.map(el => (
                <dev key={el._id} className="AboutUs__logo">
                  <img className='AboutUs__logo-img' src={el.image} />
                </dev>
              ))}
            </div>*/}
            {/* <div className="swiperLogos">
              <div className="AboutUs__swiper_logos-wrap Swiper">
                <button onClick={()=>goPrev(this.swiperRef2)} className="AboutUs__swiper1-button-prev"></button>
                <Swiper {...params_logos}  ref={instance=>this.swiperRef2=instance} className="AboutUs__swiper" slidesPerView={(window.innerWidth < 667) ? 1 : 3}>
                  {logos.map((el, index) =>
                  (
                    <div className='AboutUs__item-body' key={index}>
                      <span className='AboutUs__item-img-wrap'>
                        <img className='AboutUs__item-img_partners' src={el.image} alt={el.text} />
                      </span>
                    </div>
                  ))}
                </Swiper>
                <button onClick={()=>goNext(this.swiperRef2)} className="AboutUs__swiper1-button-next"></button>
              </div>
            </div>
          </div> */}

          {/* HIDDEN: Наша команда
          <div className="AboutUs__margin-s">
            <div className="AboutUs__header">
              Наша команда
            </div>
            <div className="AboutUs__team-wrap">
              {team.map(el => (
                <Link className="Lot" key={el.id}>
                  <div className='Lot__inner'>
                    <img className='Lot__img' src={el.image} alt={el.text} />
                    <span className={[ 'Lot__name SubHead', 'Lot__name_bottom' ].join(' ')}>{el.text} <br></br> <span style={{ fontSize: '0.8em' }}>{el.job}</span> <br></br> {el.email}</span>
                    <div className='Lot__gradient' />
                  </div>
                </Link>)
              )}
            </div>
          </div>
          */}

          {/*<div className="AboutUs__margin-m">*/}
          {/*  <div className="AboutUs__header">*/}
          {/*    О нас говорят*/}
          {/*  </div>*/}
          {/*  <div className="AboutUs__swiperVideo-wrap">*/}
          {/*    <button onClick={()=>goPrev(this.swiperRefVideo)} className="AboutUs__swiper1-button-prev"></button>*/}
          {/*    <Swiper {...paramsVideo} ref={instance => this.swiperRefVideo = instance} >*/}
          {/*      {videoArr.map(el => (*/}
          {/*        <dev className='AboutUs__item-body-video' key={el.id}>*/}
          {/*          <span className='AboutUs__item-img-wrap'>*/}
          {/*            <div className='video-container' >*/}
          {/*              <iframe title="youtube_frame" src={el.url} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope;*/}
          {/*              picture-in-picture" allowFullScreen></iframe>*/}
          {/*            </div>*/}
          {/*          </span>*/}
          {/*          <span className='AboutUs__item-caption'>*/}
          {/*            <span className='AboutUs__item-label-video'>{el.text}</span>*/}
          {/*          </span>*/}
          {/*        </dev>*/}
          {/*      ))}*/}
          {/*    </Swiper>*/}
          {/*    <button onClick={()=>goNext(this.swiperRefVideo)} className="AboutUs__swiper1-button-next"></button>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>

        <div className="AboutUs__Orange">
          <div className="AboutUs__header">
            Как внести свой вклад?
          </div>
          <div className="AboutUs__text">
          Вы можете помочь нам улучшить сферу благотворительности в России, поддержав проект. Мы ценим каждый вклад и в разы преумножаем его, разрабатывая новые инструменты помощи для тех, кому она особенно необходима.
          </div>
          {/*<div className="AboutUs__Button">
            <Link to='/contacts' className='Button Button_black'>
              Присоединиться
            </Link>
          </div>*/}
          {/*<div className="AboutUs__donate">
            <HelpForm notRequired={{'name': true, 'phone': true}} hide={{'phone': true}}/>
          </div>*/}
          <div className="AboutUs__donate">
            <Link to='/help' className='Button Button_black'>
              Хочу помочь!
            </Link>
          </div>
        </div>

        <div className="AboutUs__white">
          <div className="AboutUs__margin-m">
            <div className="AboutUs__header">
              Часто задаваемые вопросы
            </div>
            {faq.map((el, index) => (
              <div className="AboutUs__question" key={index}>
                <Hide title={el.question} text={el.answer.replace(/<\/?[a-zA-Z]+>/gi,'').replace(/&nbsp;/g,'')} />
              </div>)
            )}
          </div>

          <div className="AboutUs__header">
            Уставные документы
          </div>
          <div className="AboutUs__pdf">
            <a className="AboutUs__pdf-item" href="/assets/files/docs/01.jpeg" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text">Свидетельство о постановке на учёт</div>
            </a>
            <a className="AboutUs__pdf-item" href="/assets/files/docs/02.jpeg " target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text">Свидетельство о регистрации</div>
            </a>
            <a className="AboutUs__pdf-item" href="/assets/files/docs/03.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text">Устав АНО</div>
            </a>
            <a className="AboutUs__pdf-item" href="/assets/files/docs/04.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text">Реквизиты АНО "Мит Фор Черити"</div>
            </a>
            <a className="AboutUs__pdf-item" href="/assets/files/docs/05.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text">Программа содействия развитию благотворительности Meet for Charity </div>
            </a>
            {/*<a className="AboutUs__pdf-item" href="/assets/files/docs/06.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text">Регламент встреч</div>
            </a>*/}
          </div>
          <div className="AboutUs__header">
            Отчетность
          </div>
          <div className="AboutUs__pdf">
            <a className="AboutUs__pdf-item" href="/assets/files/docs/report_minust2020.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text"><FormattedMessage id='report_minust'/> 2020</div>
            </a>
            <a className="AboutUs__pdf-item" href="/assets/files/docs/report_minust2021.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text"><FormattedMessage id='report_minust'/> 2021</div>
            </a>
            <a className="AboutUs__pdf-item" href="/assets/files/docs/report_minust2022.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text"><FormattedMessage id='report_minust'/> 2022</div>
            </a>
            <a className="AboutUs__pdf-item" href="/assets/files/docs/report_minust2023.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text"><FormattedMessage id='report_minust'/> 2023</div>
            </a>
            <a className="AboutUs__pdf-item" href="/assets/files/docs/report_minust2024.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text"><FormattedMessage id='report_minust'/> 2024</div>
            </a>
            <a className="AboutUs__pdf-item" href="/assets/files/docs/report_minust2025.pdf" target="_blank">
              <button type="button" className="AboutUs__pdf-button"><FileLogo /></button>
              <div className="AboutUs__pdf-text"><FormattedMessage id='report_minust'/> 2025</div>
            </a>
          </div>
        </div>

      </div>
    </div>

  )
}

const mapStateToProps = state => ({
  funds: getFundsSelector(state),
  //...getExternalPartnersList(state),
  currentLocale: state.intl.locale,
  //sum: state.externalpayments.sum,
  //count: state.externalpayments.count
  total: getTotalSum(state),
  faq: state.faq.items
  //...state.CP
})

const mapDispatchToProps = dispatch => bindActionCreators({getHomeData, getTotalFunds, getFunds, getFAQ
}, dispatch)

const mergeProps = (state, dispatch, props) => ({
  ...state,
  ...props,
  getData: () => {
    //dispatch.clearList()
    return Promise.all([
      dispatch.getHomeData(),
      //dispatch.getNews({ limit: 3 }),
      dispatch.getFunds(0, { limit: 6, withoutProcessing: true }),
      dispatch.getTotalFunds(),
      dispatch.getFAQ()
      //dispatch.getPartners()
    ])
  }
})

export default compose(
  withState('focusSlide', 'setFocusSlide', undefined),
  withState('ordinaryMode', 'setOrdinaryMode', false),//одно изображение в свайпере
  fetchingState(),//
  connect(mapStateToProps, mapDispatchToProps, mergeProps
  ),
  withHandlers({
    setSize: (props) => e => {
      if (window.innerWidth < 667)
        props.setOrdinaryMode(true)
      else
        props.setOrdinaryMode(false)
    },
  }),
  lifecycle({
    async componentWillMount() {
      await this.props.getData()
      //this.props.getExternalPartners(0, false)//
      //this.props.getSumOfExternalPayments()
      this.props.setSize()
      window.addEventListener('resize', this.props.setSize);
    },
    componentWillUnmount() {
      window.removeEventListener('resize', this.props.setSize);
    }
  })
)(AboutUs)



// WEBPACK FOOTER //
// ./src/containers/AboutUs.jsx